import { importMenu } from "./import-menu";
import { deliverySettings } from "./settings";
import { deliveryReport } from "./report";
import { deliveryMenus } from "./menus";
import { syncMenu } from "./sync-menu";

export const delivery = {
	goBack: "Retour",
	updateManyExternalIntegrations: {
		success: "Integrations mises jour avec succs",
	},
	externalStoreIntegrationStatus: {
		synced: "Synchronisé",
		pendingSyncing: "Synchronisation en attente",
		pendingImporting: "Importation en attente",
	},
	ordersManager: {
		title: "Gestionnaire de commandes",
		description:
			"Suivez et gérez les commandes qui arrivent d'Entregue já, Comanda Online et Pedido na mesa.",
		filter: {
			placeholder: "Filtrer par",
		},
		tabs: {
			newOrders: "Nouvelles commandes",
			inDelivery: "En livraison",
			completed: "Terminées",
		},
		createOrder: "Créer une commande",
		loading: "Chargement",
		total: "Total: {{value}}",
		new: "Nouveau",
		emptyState: {
			title: "Aucune commande {{status}}.",
			description:
				"Nous vous enverrons une notification lorsque vous recevrez une nouvelle commande.",
		},
	},
	deliverySettings,
	deliveryReport,
	deliveryMenus,
	syncMenu,
	importMenu,
};
